export const isMasterUserLogin = (login: AuthLogin) => {
    return undefined === login.companyUnitIds;
}
